var _defs, _metadata;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWifi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsDc: "http://purl.org/dc/elements/1.1/",
    xmlnsCc: "http://creativecommons.org/ns#",
    xmlnsRdf: "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    xmlns: "http://www.w3.org/2000/svg",
    width: 317.5625,
    height: 255.34775,
    id: "svg2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs4"
  })), _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", {
    id: "metadata7"
  }, /*#__PURE__*/React.createElement("rdfRDF", null, /*#__PURE__*/React.createElement("ccWork", {
    rdfAbout: ""
  }, /*#__PURE__*/React.createElement("dcFormat", null, "image/svg+xml"), /*#__PURE__*/React.createElement("dcType", {
    rdfResource: "http://purl.org/dc/dcmitype/StillImage"
  }), /*#__PURE__*/React.createElement("dcTitle", null))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-213.58559,-301.30434)",
    id: "layer1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 225.4375,120.5 c -28.39805,0 -54.49374,11.49013 -73.5625,30.21875 l 21.15625,21.125 C 186.42608,158.71247 204.79404,150.5 225.4375,150.5 c 21.07203,0 39.78209,8.54388 53.21875,22.15625 l 21.125,-21.125 C 280.66836,132.3241 254.24255,120.5 225.4375,120.5 z",
    transform: "translate(146.64809,300.77309)",
    style: {
      fontSize: "medium",
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      textIndent: 0,
      textAlign: "start",
      textDecoration: "none",
      lineHeight: "normal",
      letterSpacing: "normal",
      wordSpacing: "normal",
      textTransform: "none",
      direction: "ltr",
      blockProgression: "tb",
      writingMode: "lr-tb",
      textAnchor: "start",
      baselineShift: "baseline",
      color: "#000000",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 1.01280868,
      marker: "none",
      visibility: "visible",
      display: "inline",
      overflow: "visible",
      enableBackground: "accumulate",
      fontFamily: "Sans",
      InkscapeFontSpecification: "Sans"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 372.05336,495.71009 c -15.91445,0 -30.47712,13.01383 -30.47712,30.471 0,17.45718 14.56267,30.471 30.47712,30.471 15.91446,0 30.46488,-13.01382 30.46488,-30.471 0,-17.45717 -14.55042,-30.471 -30.46488,-30.471 z",
    style: {
      fontSize: "medium",
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      textIndent: 0,
      textAlign: "start",
      textDecoration: "none",
      lineHeight: "normal",
      letterSpacing: "normal",
      wordSpacing: "normal",
      textTransform: "none",
      direction: "ltr",
      blockProgression: "tb",
      writingMode: "lr-tb",
      textAnchor: "start",
      baselineShift: "baseline",
      color: "#000000",
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1,
      marker: "none",
      visibility: "visible",
      display: "inline",
      overflow: "visible",
      enableBackground: "accumulate",
      fontFamily: "Sans",
      InkscapeFontSpecification: "Sans"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 225.46875,60.5 c -44.9975,0 -86.11886,18.242473 -116.0625,47.875 l 21.15625,21.09375 c 24.26306,-24.00839 57.66092,-38.9375 94.90625,-38.9375 37.61358,0 71.28178,15.22933 95.5625,39.65625 l 21.125,-21.15625 C 312.19677,79.002856 270.80502,60.5 225.46875,60.5 z",
    transform: "translate(146.64809,300.77309)",
    style: {
      fontSize: "medium",
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      textIndent: 0,
      textAlign: "start",
      textDecoration: "none",
      lineHeight: "normal",
      letterSpacing: "normal",
      wordSpacing: "normal",
      textTransform: "none",
      direction: "ltr",
      blockProgression: "tb",
      writingMode: "lr-tb",
      textAnchor: "start",
      baselineShift: "baseline",
      color: "#000000",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 1.03394938,
      marker: "none",
      visibility: "visible",
      display: "inline",
      overflow: "visible",
      enableBackground: "accumulate",
      fontFamily: "Sans",
      InkscapeFontSpecification: "Sans"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 225.46875,0.53125 C 163.91062,0.53125 107.74973,25.480521 66.9375,66 l 21.15625,21.125 c 35.10739,-34.905172 83.49852,-56.59375 137.375,-56.59375 54.18812,0 102.82123,21.926707 137.9375,57.1875 L 384.5,66.5625 C 343.68121,25.711691 287.31103,0.53125 225.46875,0.53125 z",
    transform: "translate(146.64809,300.77309)",
    style: {
      fontSize: "medium",
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      textIndent: 0,
      textAlign: "start",
      textDecoration: "none",
      lineHeight: "normal",
      letterSpacing: "normal",
      wordSpacing: "normal",
      textTransform: "none",
      direction: "ltr",
      blockProgression: "tb",
      writingMode: "lr-tb",
      textAnchor: "start",
      baselineShift: "baseline",
      color: "#000000",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 1.07882667,
      marker: "none",
      visibility: "visible",
      display: "inline",
      overflow: "visible",
      enableBackground: "accumulate",
      fontFamily: "Sans",
      InkscapeFontSpecification: "Sans"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWifi);
export default __webpack_public_path__ + "static/media/wifi.ba5ba9f5a1edaa4829921932bafbb9a5.svg";
export { ForwardRef as ReactComponent };